import React from 'react';
import Contact from '../Contact';
import Header from '../../Header/Header'
import Footer from '../../Footer/Footer'

const ContactItem = () => {
    return (
        <div>
            <Header></Header>
            <Contact></Contact>
            <Footer></Footer>
        </div>
    );
};

export default ContactItem;